console.log('you can use ES6 here : )');
var marked = require('marked');
console.log(marked('- Design & Development\n- Full Responsive\n- CMS (Wordpress)')); 

import $ from 'jquery';
import {TweenLite, Power2, TimelineLite} from "gsap";

// $('h1').html("new text")   
$('.hamburger').click(function() {
    $('.hamburger').toggleClass('is-active');
});
// Hamburger reverse animation
$(".hamburger").click(function() {
        
        if (!$('.hamburger').hasClass('is-active')) {
        // $('.hamburger').addClass('is-active')
        tl.reverse(0.4);
        
        } else {
        // $('.hamburger').removeClass('is-active')
        tl.play();
        }
});



// Variables
var fill, tl, head, social, top, hoverFill;
  head = $(".fill ul li");
  top = $(".fill ul");
  social = $(".fill .mobile-share");
  hoverFill = $(".works-cover");
  fill = $(".fill");
  
  // New Timeline Created
  tl = new TimelineLite();
    tl.pause();
    tl.to(fill, 0.1, {
        opacity: "1",
        display: "block"
        });
    tl.from(top, 0.3, {opacity:"0"}, 0.1);
    tl.from(head, 0.3, {opacity:"0", left:0}, 0.1);
    tl.to(social, 0.2, {opacity:"1"}, '-=0.1')

$(".works-cover, .works-content").hover(function(){
    TweenLite.to($(this), 0.2, {opacity:"1", ease: Power4.easeIn});
});


$(".works-cover").mouseout(function(){
    TweenLite.to(hoverFill, 0.2, {opacity:"0"});
});
    


// WEBPACK FOOTER //
// ./assets/js/index.js